import { useEffect, useState } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "../firebase-config"; // Your Firebase config file

export const useAuth = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setIsAuthenticated(!!user); // Set true if a user is logged in, otherwise false
      setLoading(false); // Stop loading when Firebase checks are done
    });

    return () => unsubscribe(); // Cleanup subscription
  }, []);

  return { isAuthenticated, loading }; // Return authentication status and loading state
};
